import { render, staticRenderFns } from "./indexs.vue?vue&type=template&id=68e39a93&scoped=true"
import script from "./indexs.vue?vue&type=script&lang=js"
export * from "./indexs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e39a93",
  null
  
)

export default component.exports